import styled from 'styled-components';

export const Title3 = styled.h3`
  font-size: 18px;
  color: ${props => props.theme.darkBlue};
  font-weight: 600;
  margin: 0;
`;
